import React from 'react'
import OrderHeader from 'shared/component/orderHeader/orderHeader'
import ImgTruck from 'shared/assets/images/svg/truck_order.svg'
import Confirm from 'shared/assets/images/svg/confirm_green.svg'
import Edit from 'shared/assets/images/svg/edit_dark.svg'
import Delete from 'shared/assets/images/svg/delete_red.svg'
import Back from "shared/assets/images/svg/back_blue.svg";
import IconDate from 'shared/assets/images/svg/date_bl_md.svg'
import RouteBl from 'shared/assets/images/svg/route_bl_md.svg';
import MapBl from 'shared/assets/images/svg/map_bl_md.svg';
import { useCustomerOrders } from "customer/orders/customer-orders.service";
import { OrderState } from "shared/helpers/constants";
import { formatDate } from "shared/helpers/utils";
import { Link } from 'react-router-dom'
import TextArea from 'shared/component/textArea'
import Input from 'shared/component/inputFields'

const ViewOrder = () => {

    return (
        <div className="viewOrder pending summary">
            <div className="container">
                <div className='header'>
                   <div className='page-name'>
                   <Link className='linkBack' to="/pending">
                   <img src={Back} alt="back" />
                   </Link>
                    <h1 className='title'>Back</h1>
                   </div>
                </div>
                    <hr className='hr' />
                <div className="box-pending">
                    <div className="status">
                        <img className="imgTruck" src={ImgTruck} alt="ImgTruck" />
                        <span className="approved">approved</span>
                    </div>
                    <div className="all-info">
                        <div className="div-top">
                            <div className="info">
                                <h1 className="title">Ali Mahmoud</h1>
                                <span className="serial">32163216532532</span>
                                <span className="date">25/06/2021 - 15:35</span>
                            </div>
                            <div className="action">
                                <button className="confirm">
                                    <img src={Confirm} alt="Confirm" />
                                    Confirm
                                </button>
                                <button className="edit">
                                    <img src={Edit} alt="Confirm" />
                                    Edit
                                </button>
                            </div>
                        </div>
                        <hr className="hr" />
                        <div className="div-bottom">
                            <div className="info">
                                <div className="box">
                                    <h1>From</h1>
                                    <span>Address Title</span>
                                </div>
                                <div className="box">
                                    <h1>Pickup Date:</h1>
                                    <span>25/06/2021 15:35</span>
                                </div>
                                <div className="box">
                                    <h1>Estimated Time</h1>
                                    <span className="green">48 Hours</span>
                                </div>
                                <div className="box">
                                    <h1>Driver</h1>
                                    <span>Mohamed Ahmed</span>
                                </div>
                            </div>
                            <div className="div-price">
                                <h1 className="price">
                                    3815.32 <span>SAR</span>
                                </h1>
                            </div>
                        </div>
                    </div>
                    <div className="close">
                        <img
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="delete"
                            className="delete"
                            src={Delete}
                            alt="Delete"
                        />
                    </div>
                </div>
                <div className='row'>
                <div className='col-md-8'>
                        <div className='summary-details'>
                            <div className='details'>
                                <h1 className='title'>Shipping Details</h1>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Responsible Person:" value="Ahmed Ali" readonly />
                                    </div>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Vehicle Type:" value="Truck12" readonly />
                                    </div>
                                </div>
                            </div>

                            <div className='details'>
                                <h1 className='title'>Goods Details</h1>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Goods Type:" value="Lorem Goods Type" readonly />
                                    </div>
                                    <div className='col-md-4'>
                                        <Input type="text" label="Goods Wight:" value="750" readonly />
                                    </div>
                                    <div className='col-md-2'>
                                        <Input type="text" label="Unit:" value="Kgm" readonly />
                                    </div>
                                    <div className='col-md-12'>
                                        <TextArea label="Goods Discerption:" value="Sed Ut Perspiciatis Unde Omnis Iste Natus Error Sit Voluptatem Accusantium Doloremque Laudantium, Totam Rem Aperiam, Eaque Ipsa Quae Ab Illo Inventore Veritatis Et Quasi Architecto Beatae Vitae Dicta Sunt Explicabo" readonly />
                                    </div>
                                </div>
                            </div>
                            <div className='details'>
                                <h1 className='title'>From Details <span>(Pickup Point)</span></h1>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <Input type="text" label="From:" value="City Name Goes Here" readonly />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Contact Person:" value="Name Goes Here" readonly />
                                    </div>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Phone:" value="+961 123456789" readonly />
                                    </div>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Address:" value="Address Name Goes Here" readonly />
                                    </div>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Location:" value="Location Details Goes Here" readonly />
                                    </div>
                                    <div className='col-md-12'>
                                        <TextArea label="Address Details:" value="Sed Ut Perspiciatis Unde Omnis Iste Natus Error Sit Voluptatem Accusantium Doloremque Laudantium, Totam Rem Aperiam, Eaque Ipsa Quae Ab Illo Inventore Veritatis Et Quasi Architecto Beatae Vitae Dicta Sunt Explicabo" readonly />
                                    </div>
                                </div>
                            </div>
                            <div className='details'>
                                <h1 className='title'>To Details <span>(Delivery Point)</span></h1>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <Input type="text" label="to:" value="City Name Goes Here" readonly />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Contact Person:" value="Name Goes Here" readonly />
                                    </div>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Phone:" value="+961 123456789" readonly />
                                    </div>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Address:" value="Address Name Goes Here" readonly />
                                    </div>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Location:" value="Location Details Goes Here" readonly />
                                    </div>
                                    <div className='col-md-12'>
                                        <TextArea label="Address Details:" value="Sed Ut Perspiciatis Unde Omnis Iste Natus Error Sit Voluptatem Accusantium Doloremque Laudantium, Totam Rem Aperiam, Eaque Ipsa Quae Ab Illo Inventore Veritatis Et Quasi Architecto Beatae Vitae Dicta Sunt Explicabo" readonly />
                                    </div>
                                </div>
                            </div>
                            <div className='details'>
                                <h1 className='title'>Stop No. 1</h1>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <Input type="text" label="From:" value="City Name Goes Here" readonly />
                                    </div>
                                    <div className='col-md-6'>
                                        <Input type="text" label="To:" value="City Name Goes Here" readonly />
                                    </div>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Contact Person:" value="Name Goes Here" readonly />
                                    </div>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Phone:" value="+961 123456789" readonly />
                                    </div>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Address:" value="Address Name Goes Here" readonly />
                                    </div>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Location:" value="Location Details Goes Here" readonly />
                                    </div>
                                    <div className='col-md-12'>
                                        <TextArea label="Address Details:" readonly value="Sed Ut Perspiciatis Unde Omnis Iste Natus Error Sit Voluptatem Accusantium Doloremque Laudantium, Totam Rem Aperiam, Eaque Ipsa Quae Ab Illo Inventore Veritatis Et Quasi Architecto Beatae Vitae Dicta Sunt Explicabo" />
                                    </div>
                                    <div className='col-md-12'>
                                        <div className='div-hints'>
                                            <p>action on order depends on status and will be shown at the end of every order please click here to view order journey</p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='summary-info'>
                            <div className='box-from'>
                                <div className='box-header'>
                                    <div className='from'>
                                        <span>from</span>
                                        <h2>Address Name</h2>
                                    </div>
                                    <div className='to'>
                                        <span>to</span>
                                        <h2>Customer Name</h2>
                                    </div>
                                </div>
                                <div className='inf0'>
                                    <img src={IconDate} alt='IconDate' />
                                    <h3>10/24/2021 - 02:00 PM</h3>
                                </div>
                                <div className='inf0'>
                                    <img src={RouteBl} alt='RouteBl' />
                                    <h3>3 STOPS INCLUDED</h3>
                                </div>

                                <div className='inf0'>
                                    <img src={MapBl} alt='MapBl' />
                                    <h3>External</h3>
                                </div>
                            </div>
                            <div className='box-cost'>
                                <h1 className='title'>SUMMARY</h1>
                                <div className='cost-info dimmed'>
                                    <p>Total</p>
                                    <span>2,765</span>
                                </div>
                                <div className='cost-info dimmed'>
                                    <p>Stop Cost</p>
                                    <span>3x150</span>
                                </div>
                                <div className='cost-info dimmed'>
                                    <p>Discount</p>
                                    <span>-150</span>
                                </div>
                                <hr className='hr dotted'/>
                                <div className='cost-info dark'>
                                    <p>Subtotal</p>
                                    <span className='bold'>3215.32</span>
                                </div>
                                <div className='cost-info dimmed'>
                                    <p>15% VAT</p>
                                    <span>450</span>
                                </div>
                                <hr className='hr dotted' />
                                <div className='cost-info dark'>
                                    <p>Net Total</p>
                                    <span  className='bold'>3600</span>
                                </div>
                                <div className='cost-info dimmed'>
                                    <p>Outstanding Amounts</p>
                                    <span>150</span>
                                </div>
                                <hr className='hr' />
                                <div className='cost-info dark amount'>
                                    <p>Invoice Amount</p>
                                    <span>5000.00 <span>EGP</span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default ViewOrder